/* eslint-disable react/prop-types */
import React, { createContext, useMemo, useState } from "react";
import Toast from "../../components/Toast/index";
import { AlertStatus } from "../../contants";

export const ToastAlertContext = createContext();

function ToastAlertProvider({ children }) {
  // console.log(children);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(AlertStatus.WARNING);
  const [message, setMessage] = useState("");

  const openAlert = () => setOpen(true);
  const closeAlert = () => setOpen(false);

  // a: message
  // b: status
  const show = (a, b) => {
    setMessage(a);
    setStatus(b);
    openAlert();
  };

  const value = useMemo(
    () => ({
      show,
      closeAlert,
    }),
    [],
  );

  return (
    <ToastAlertContext.Provider value={value}>
      <Toast
        open={open}
        severity={status}
        handleClose={closeAlert}
        message={message}
      />
      {children}
    </ToastAlertContext.Provider>
  );
}

export default ToastAlertProvider;
